var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 5.875H18.125C19.5057 5.875 20.625 6.99429 20.625 8.375V18.375C20.625 19.7557 19.5057 20.875 18.125 20.875H3.125C1.74429 20.875 0.625 19.7557 0.625 18.375V8.375C0.625 6.99429 1.74429 5.875 3.125 5.875ZM3.125 7.375C2.57272 7.375 2.125 7.82272 2.125 8.375V18.375C2.125 18.9273 2.57272 19.375 3.125 19.375H18.125C18.6773 19.375 19.125 18.9273 19.125 18.375V8.375C19.125 7.82272 18.6773 7.375 18.125 7.375H3.125Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 11.125C6.625 12.0915 5.8415 12.875 4.875 12.875C3.9085 12.875 3.125 12.0915 3.125 11.125C3.125 10.1585 3.9085 9.375 4.875 9.375C5.8415 9.375 6.625 10.1585 6.625 11.125Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 17.0965L5.17 14.0311C5.29273 13.8471 5.47974 13.7324 5.68276 13.7165C5.88578 13.7006 6.08493 13.7851 6.22883 13.9481L7.38047 15.2534L11.4787 10.6086C11.7534 10.2971 12.199 10.2971 12.4738 10.6086L18.125 17.0136V18.375H3.125V17.0965Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 5.875C3.375 4.35622 4.60622 3.125 6.125 3.125H20.625C22.1438 3.125 23.375 4.35622 23.375 5.875V15.875C23.375 17.3938 22.1438 18.625 20.625 18.625H19.4388V17.125H20.625C21.3154 17.125 21.875 16.5654 21.875 15.875V5.875C21.875 5.18464 21.3154 4.625 20.625 4.625H6.125C5.43464 4.625 4.875 5.18464 4.875 5.875V6.79167H3.375V5.875Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/Images.948546274da668b733ed23fc0c1eecdc.svg";
export { ForwardRef as ReactComponent };